import React, { useEffect } from 'react';
import { RadioButton as AbleRadioButton } from '@able/react';

const RadioButton = ({
    input,
    label,
    isActive,
    id,
    radioValue,
    meta = {},
    updateError,
    description,
    variant
}) => {

    const { error: latestError, submitFailed = false } = meta;

    useEffect(() => {
        if (typeof updateError === 'function') {
            const errorUpdate = !!(submitFailed && latestError);
            updateError(errorUpdate);
        }
    }, [latestError, submitFailed, updateError]);

    return (
        <AbleRadioButton
            {...input}
            name={input.name}
            className="able-boost-radio"
            id={id}
            onChange={() => input.onChange(radioValue)}
            checked={isActive}
            value={radioValue}
            label={label}
            variant={variant}
            description={description}
        />
    )
}

export default RadioButton;
